import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import { useSelector } from "react-redux";

const decodeJwtPayload = (token: string) => {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    } catch (e) {
        return null;
    }
};

const isCompanyInformationComplete = (company: any) => {
    if (!company) return false;

    const isDefaultInfo = 
        company.address === 'Dirección por defecto - Actualizar después' &&
        company.ruc === '9999999999999' &&
        (!company.phone || company.phone === '');
    
    if (isDefaultInfo) return false;

    return !!(
        company.businessName &&
        company.ruc && 
        company.address &&
        company.address !== 'Dirección por defecto - Actualizar después' &&
        company.ruc !== '9999999999999' &&
        company.ruc.length === 13
    );
};

const Navdata = () => {
    const history = useNavigate();
    const { selectedCompany } = useSelector((state: any) => state.Companies);
    
    //state data
    const [isDashboard, setIsDashboard] = useState(false);
    const [isCatalogs, setIsCatalogs] = useState<boolean>(false);
    const [isApps, setIsApps] = useState(false);
    const [isAuth, setIsAuth] = useState(false);
    const [isCompany, setIsCompany] = useState(false);
    const [isBilling, setIsBilling] = useState(false);
    const [isRemissionGuide, setIsRemissionGuide] = useState(false);
    const [isPages, setIsPages] = useState(false);
    const [isBaseUi, setIsBaseUi] = useState(false);
    const [isAdvanceUi, setIsAdvanceUi] = useState(false);
    const [isForms, setIsForms] = useState(false);
    const [isTables, setIsTables] = useState(false);
    const [isCharts, setIsCharts] = useState(false);
    const [isIcons, setIsIcons] = useState(false);
    const [isProducts, setIsProducts] = useState(false);
    const [isCustomers, setIsCustomers] = useState(false);
    const [isMaps, setIsMaps] = useState(false);
    const [isMultiLevel, setIsMultiLevel] = useState(false);

    const [iscurrentState, setIscurrentState] = useState('Dashboard');
    const [isCatalog, setIsCatalog] = useState(false);

    const [userRoles, setUserRoles] = useState<string[]>([]);

    const [hasRestrictions, setHasRestrictions] = useState(false);

    useEffect(() => {
        const authUser = localStorage.getItem("authUser");
        if (authUser) {
            try {
                const parsedUser = JSON.parse(authUser);
                if (parsedUser.token) {
                    const decoded = decodeJwtPayload(parsedUser.token);
                    if (decoded && decoded.roles && Array.isArray(decoded.roles)) {
                        const roles = decoded.roles.map((role: any) => role.name);
                        setUserRoles(roles);

                        // Verificar si hay restricciones
                        const isSuperAdmin = roles.includes('Super Admin');
                        const isAdmin = roles.includes('Admin') && !isSuperAdmin;
                        const isUser = roles.includes('User') && !isAdmin && !isSuperAdmin;
                        const companyId = decoded.companyId;
                        
                        // Super Admin nunca tiene restricciones
                        if (isSuperAdmin) {
                            setHasRestrictions(false);
                        } else if (isUser && !companyId) {
                            // User sin compañía - tiene restricciones
                            setHasRestrictions(true);
                        } else if (isUser && companyId && selectedCompany && !isCompanyInformationComplete(selectedCompany)) {
                            // User con compañía incompleta - tiene restricciones
                            setHasRestrictions(true);
                        } else if (isAdmin && companyId && selectedCompany && !isCompanyInformationComplete(selectedCompany)) {
                            // Admin con compañía incompleta - tiene restricciones
                            setHasRestrictions(true);
                        } else if (isAdmin && !companyId) {
                            // Admin sin compañía - tiene restricciones
                            setHasRestrictions(true);
                        } else {
                            // Sin restricciones
                            setHasRestrictions(false);
                        }
                    }
                }
            } catch (error) {
                console.error("Error parsing authUser from localStorage", error);
            }
        }
    }, [selectedCompany]);

    const isSuperAdmin = userRoles.includes("Super Admin");
    const isAdmin = userRoles.includes("Admin");
    const canViewAdminItems = isSuperAdmin || isAdmin;

    function updateIconSidebar(e: any) {
        // Limpiar todos los estados activos del menú principal
        const ul: any = document.getElementById("two-column-menu");
        if (ul) {
            const iconItems = ul.querySelectorAll(".nav-icon.active, .menu-title.active");
            let activeItems = [...iconItems];
            activeItems.forEach((item) => {
                item.classList.remove("active");
            });

            // Cerrar sub-menus abiertos
            const subMenus = ul.querySelectorAll(".sub-menu.show");
            subMenus.forEach((subMenu: any) => {
                subMenu.classList.remove("show");
            });
        }
    }

    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');
        if (iscurrentState !== 'Dashboard') {
            setIsDashboard(false);
        }
        if (iscurrentState !== 'Apps') {
            setIsApps(false);
        }
        if (iscurrentState !== 'Auth') {
            setIsAuth(false);
        }
        if (iscurrentState !== 'Pages') {
            setIsPages(false);
        }
        if (iscurrentState !== 'BaseUi') {
            setIsBaseUi(false);
        }
        if (iscurrentState !== 'AdvanceUi') {
            setIsAdvanceUi(false);
        }
        if (iscurrentState !== 'Forms') {
            setIsForms(false);
        }
        if (iscurrentState !== 'Tables') {
            setIsTables(false);
        }
        if (iscurrentState !== 'Charts') {
            setIsCharts(false);
        }
        if (iscurrentState !== 'Icons') {
            setIsIcons(false);
        }
        if (iscurrentState !== 'Maps') {
            setIsMaps(false);
        }
        if (iscurrentState !== 'MultiLevel') {
            setIsMultiLevel(false);
        }
        if (iscurrentState === 'Widgets') {
            history("/widgets");
            document.body.classList.add('twocolumn-panel');
        }
        if (iscurrentState !== 'Catalogs') {
            setIsCatalog(false);
        }
        if (iscurrentState !== 'Billing') {
            setIsBilling(false);
        }
        if (iscurrentState !== 'RemissionGuide') {
            setIsRemissionGuide(false);
        }
        if (iscurrentState !== 'Products') {
            setIsProducts(false);
        }
        if (iscurrentState !== 'Customers') {
            setIsCustomers(false);
        }
        // removed unused Landing state cleanup
    }, [
        history,
        iscurrentState,
        isDashboard,
        isApps,
        isAuth,
        isPages,
        isBaseUi,
        isAdvanceUi,
        isForms,
        isTables,
        isCharts,
        isIcons,
        isMaps,
        isMultiLevel,
        isProducts,
        isBilling,
        isRemissionGuide,
        isCatalog,
        isCustomers
    ]);

    const menuItems: any = [
        {
            label: "Menu",
            isHeader: true,
        },
        {
            id: "dashboard",
            label: "Dashboard",
            icon: "ri-dashboard-line",
            link: "/dashboard",
            click: function (e: any) {
                e.preventDefault();
                setIscurrentState("Dashboard");
                updateIconSidebar(e);
                setIsDashboard(true);
                // Forzar navegación directa
                history("/dashboard");
            },
        },
        // Solo mostrar otros items si no hay restricciones
        ...(hasRestrictions ? [] : [
            {
                id: "billing-menu",
                label: "Facturas",
                icon: "ri-file-list-3-line",
                link: "/#",
                click: function (e: any) {
                    e.preventDefault();
                    setIsBilling(!isBilling);
                    setIscurrentState('Billing');
                    updateIconSidebar(e);
                },
                stateVariables: isBilling,
                subItems: [
                    {
                        id: "billing",
                        label: "Nueva factura",
                        link: "/billing",
                        parentId: "billing-menu",
                    },
                    {
                        id: "billing-list",
                        label: "Lista de facturas",
                        link: "/billing-list",
                        parentId: "billing-menu",
                    },
                ]
            },
            {
                id: "remission-guide-menu",
                label: "Guías de remisión",
                icon: "ri-truck-line",
                link: "/#",
                click: function (e: any) {
                    e.preventDefault();
                    setIsRemissionGuide(!isRemissionGuide);
                    setIscurrentState('RemissionGuide');
                    updateIconSidebar(e);
                },
                stateVariables: isRemissionGuide,
                subItems: [
                    {
                        id: "NewRemissionGuide",
                        label: "Nueva guía de remisión",
                        link: "/remission-guide",
                        parentId: "remission-guide-menu",
                    },
                    {
                        id: "RemissionGuideList",
                        label: "Lista de guías",
                        link: "/remission-guide-list",
                        parentId: "remission-guide-menu",
                    },
                ]
            },
        ...(canViewAdminItems ? [
            {
                id: "customers",
                label: "Clientes",
                icon: "ri-user-3-line",
                link: "/customers",
                stateVariables: isCustomers,
                click: function (e: any) {
                    e.preventDefault();
                    setIsCustomers(!isCustomers);
                    setIscurrentState('Customers');
                    updateIconSidebar(e);
                    history('/customers');
                },
            },
            {
                id: "company-profile",
                label: "Mi Compañía",
                icon: "ri-building-4-line",
                link: "/company-profile",
                click: function (e: any) {
                    e.preventDefault();
                    setIscurrentState('CompanyProfile');
                    history('/company-profile');
                },
            }
        ] : []),
        ...(isSuperAdmin ? [
            {
                id: "company",
                label: "Compañías",
                icon: "las la-building",
                link: "/company",
                click: function (e: any) {
                    setIscurrentState('Company');
                    updateIconSidebar(e);
                    setIsCompany(!isCompany);
                },
            },
            {
                id: "Catálogos",
                label: "Catálogos",
                icon: "ri-book-open-line",
                link: "/catalogs",
                stateVariables: isCatalogs,
                click: function (e: any) {
                    e.preventDefault();
                    setIsCatalogs(!isCatalogs);
                    setIscurrentState('Catalogs');
                    updateIconSidebar(e);
                    history('/catalogs');
                },
            },
            {
                id: "authentication",
                label: "Autenticación",
                icon: "lar la-user-circle",
                link: "/#",
                click: function (e: any) {
                    e.preventDefault();
                    setIsAuth(!isAuth);
                    setIscurrentState('Auth');
                    updateIconSidebar(e);
                },
                stateVariables: isAuth,
                subItems: [
                    {
                        id: "users",
                        label: "Usuarios",
                        link: "/auth-users-list",
                        parentId: "authentication",
                    },
                    {
                        id: "roles",
                        label: "Roles y permisos",
                        link: "/roles",
                        parentId: "authentication",
                    },
                ]

            },
        ] : [])
        ])

       /* {
            id: "products",
            label: "Productos",
            icon: "ri-archive-line",
            link: "/products",
            stateVariables: isProducts,
            click: function (e: any) {
                e.preventDefault();
                setIsProducts(!isProducts);
                setIscurrentState('Products');
                updateIconSidebar(e);
                history('/products');
            },
        },*/

    ];
    return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
